// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3OaAZ","emails":"CreateEditClinics_emails__6TImL","emailTagLabel":"CreateEditClinics_emailTagLabel__2scJz"};